export const SET_MENU = 'SET_MENU'
export const CLEAR_MENU = 'CLEAR_MENU'